import { useQuery } from '@apollo/client'
import { Typography } from '@mui/material'

import { GET_STORE, GetStoreQuery, GetStoreQueryVariables } from '@/graphql'

import { StoreHeader } from './StoreHeader'
import { StoreMainHeader } from './StoreMainHeader'

type Props = {
  id: string
  type?: 'main' | 'small'
  singleRow?: boolean
  noZip?: boolean
}

export const StoreHeaderWithQuery: React.FC<Props> = props => {
  const { id, type = 'small', singleRow, noZip } = props
  const { data } = useQuery<GetStoreQuery, GetStoreQueryVariables>(GET_STORE, {
    variables: { id },
  })
  const Header = type === 'main' ? StoreMainHeader : StoreHeader
  return data?.store.location ? (
    <Header
      {...data?.store.location}
      storeId={id}
      singleRow={singleRow}
      noZip={noZip}
    />
  ) : (
    <Typography>Loading...</Typography>
  )
}
